import {Injectable, signal} from '@angular/core';
import {DeclarationFile} from "../types/declaration-modal.types";

@Injectable({
  providedIn: 'root'
})
export class DeclarationFilesStateService {
  private _declarationFilesState = signal<Record<number, Array<DeclarationFile>>>({});
  public declarationFilesState = this._declarationFilesState.asReadonly();

  public setDeclarationFilesState(id: number, declarationFiles: Array<DeclarationFile>): void {
    this._declarationFilesState.set({
      ...this._declarationFilesState(),
      [id]: declarationFiles
    });
  }

  public getDeclarationFilesById(id: number): Array<DeclarationFile> {
    return this.declarationFilesState()[id];
  }

  public deleteFileById(fileId: number, declarationId: number): void {
    this._declarationFilesState.update(state => {
      const currentFiles = state[declarationId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [declarationId]: updatedFiles
      };
    });
  }

  public updateDeclarationFilesState(declarationId: number, declarationFile: DeclarationFile): void {
    this._declarationFilesState.update(state => {
      const currentFiles = state[declarationId] || [];
      const updatedFiles = [...currentFiles, declarationFile];

      return {
        ...state,
        [declarationId]: updatedFiles
      };
    });
  }

  public deleteDeclarationFilesState(declarationId: number): void {
    this._declarationFilesState.update(state => {
      const newState = { ...state };
      delete newState[declarationId];
      return newState;
    });
  }
}
